import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {FoldDetailService} from '../../../../../../services/apiServices/business/fold-detail.service';
import {SearchService} from '../../../../../../services/apiServices/business/search.service';
import {ActionConfirmKind} from '../../../../../../model/action-confirm-kind';
import * as moment from 'moment';
import {CommonService} from '../../../../../../services/apiServices/business/common.service';

/**
 * Represent the only fold const option
 */
const ONLY_FOLD = 'UNIT';

/**
 * Represent the all deposit option
 */
const ALL_DEPOSIT = 'LOT';

/**
 * handle actions on fold detail (like retry, discard)
 */
@Component({
  selector: 'app-action-confirm',
  templateUrl: './action-confirm.component.html',
  styleUrls: ['./action-confirm.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ActionConfirmComponent implements OnInit {

  /**
   * Const used by back-office for New run request
   */
  public NEWRUN = 'NEWRUN';

  /**
   * Const used by back-office for Restore request
   */
  public RESTORE = 'RESTORE';

  /**
   * Const used by back-office for Exclude request
   */
  public EXCLUDE = 'DISMISSED';
  /**
   * Const used by back-office for Plan request
   */
  public PLAN = 'PLAN';
  public CANCEL_PLAN = 'CANCEL_PLAN';
  /**
   * the user choice for displaying Restart or Exclude
   */
  @Input('kindOfActionConfirm') public kindOfActionConfirm: number;

  /**
   * here to perform coherent request
   */
  @Input('fold') public fold;

  /**
   * here for updateOrSaveVisible purpose (modal closing)
   */
  @Output() public visible: EventEmitter<boolean>;

  /**
   * the modal title
   */
  public modalTitle: string;

  /**
   * the validation button label
   */
  public buttonLabel: string;

  /**
   * text typed by the user
   */
  public justification: string;

  /**
   * Message title display when action was not perfomed succesfully
   */
  public errorTitle: string;

  /**
   * Message display when action was not perfomed succesfully
   */
  public errorMessage: string;

  /**
   * label for only fold option
   */
  private labelOnlyFold: string;

  /**
   * label for all deposit option
   */
  private labelAllDeposit: string;

  /**
   * list of possible choice (currently : only fold or all deposit)
   */
  public actions: any[];

  /**
   * the selected action (deposit or fold)
   */
  public selectedAction: string;

  /**
   * if the user select all deposit, it should represent the number of concerned folds
   */
  public numberOfConcernedFold;

  public displayConfirmReplay = true;
  public maxDelayedSendDate: Date;
  public minDelayedSendDate: Date;
  public delayedSendDate: Date;

  /**
   *
   * default constructor, just here for instantiating variables
   *
   * @param {TranslateService} translateService - here for translation purposes
   * @param {FoldDetailService} foldDetailService - here to perform request
   * @param commonService
   * @param {SearchService} searchService - here to perform a search update after success on request
   */
  constructor(private translateService: TranslateService, private foldDetailService: FoldDetailService, private commonService: CommonService,
              private searchService: SearchService) {
    this.visible = new EventEmitter<boolean>();
  }

  /**
   * handle context variation on launch
   */
  public ngOnInit(): void {
    this.delayedSendDate = null;
    let nowDate = moment();
    nowDate.add(3, 'days');
    this.minDelayedSendDate = nowDate.toDate();
    nowDate = moment();
    nowDate.add(3, 'months');
    this.maxDelayedSendDate = nowDate.toDate();
    this.getTradForNonContextualElement();
    this.createActions();
    switch (this.kindOfActionConfirm) {
      case ActionConfirmKind.NEWRUN:
        this.tradForNewRun();
        break;
      case ActionConfirmKind.RESTORE:
        this.tradForRestore();
        break;
      case ActionConfirmKind.EXCLUDE:
        this.tradForExclude();
        break;
      case ActionConfirmKind.PLAN:
        this.tradForPlan();
        break;
    }
  }
  /**
   * fill action possibilites
   */
  private createActions(): void {
    this.actions = [];
    this.actions.push({label: this.labelOnlyFold, value: ONLY_FOLD});
    this.actions.push({label: this.labelAllDeposit, value: ALL_DEPOSIT});
    this.selectedAction = ONLY_FOLD;
    this.numberOfConcernedFold = 1;
  }

  public getNumberOfConcernerdFolds(): void {
    if (this.selectedAction === ONLY_FOLD) {
      this.numberOfConcernedFold = 1;
    } else {
      let action;

      switch (this.kindOfActionConfirm) {
        case ActionConfirmKind.NEWRUN:
          action = this.NEWRUN;
          break;
        case ActionConfirmKind.EXCLUDE:
          action = this.EXCLUDE;
          break;
        case ActionConfirmKind.RESTORE:
          action = this.RESTORE;
          break;
          case ActionConfirmKind.PLAN:
          action = this.PLAN;
          break;
          case ActionConfirmKind.CANCEL_PLAN:
          action = this.CANCEL_PLAN;
          break;
      }

      this.foldDetailService.getNumberOfFoldByDepositNumber(this.fold.lSerialLotDepot, action).subscribe(response => {
        this.numberOfConcernedFold = response;
      });

    }
  }

  /**
   * get the title for exclude modal
   */
  private tradForExclude(): void {
    this.translateService.get('FOLD.ACTION_COMPONENT.EXCLUDE_MODAL_TITLE').subscribe((title: string) => {
      this.modalTitle = title;
    });
  }
  /**
   * get the title for exclude modal
   */
  private tradForPlan(): void {
    this.translateService.get('FOLD.ACTION_COMPONENT.PLAN_MODAL_TITLE').subscribe((title: string) => {
      this.modalTitle = title;
    });
  }
  /**
   * get the title for nowReun modal
   */
  private tradForNewRun(): void {
    this.translateService.get('FOLD.ACTION_COMPONENT.NEWRUN_MODAL_TITLE').subscribe((title: string) => {
      this.modalTitle = title;
    });
  }

  /**
   * get the title for Restore modal
   */
  private tradForRestore(): void {
    this.translateService.get('FOLD.ACTION_COMPONENT.RESTORE_MODAL_TITLE').subscribe((title: string) => {
      this.modalTitle = title;
    });
  }

  /**
   * Dispatch request regarding the context
   */
  public processRequest(): void {
    let action;

    switch (this.kindOfActionConfirm) {
      case ActionConfirmKind.NEWRUN:
        action = this.NEWRUN;
        break;
      case ActionConfirmKind.EXCLUDE:
        action = this.EXCLUDE;
        break;
      case ActionConfirmKind.RESTORE:
        action = this.RESTORE;
        break;
        case ActionConfirmKind.PLAN:
        action = this.PLAN;
        break;
        case ActionConfirmKind.CANCEL_PLAN:
        action = this.CANCEL_PLAN;
        break;
    }
    this.handleRequest(action);
  }

  /**
   * perform request and handle return
   */
  private handleRequest(action): void {

    let serialLotDepot = this.fold.lSerialLotDepot;
    let serialSent = this.fold.serialSent;

    // Just there for good understood of the problem
    if (this.selectedAction === ONLY_FOLD) {
      serialLotDepot = '';
    } else if (this.selectedAction === ALL_DEPOSIT) {
      serialSent = '';
    }

    this.foldDetailService.actionOnFold(this.justification, serialLotDepot, serialSent, action, this.selectedAction, this.delayedSendDate).subscribe(response => {
      if (response.bOK) {
        // noinspection JSUnusedLocalSymbols
        this.searchService.performLastSearch().subscribe(res => {
          this.closeComponent();
        });
      } else {
        this.commonService.addToast({
          life: 3000,
          severity: 'error',
          summary: this.errorTitle,
          detail: this.errorMessage
        });
      }
    });
  }

  /**
   * handle translation for non contextual element (like messages to display in case of fail)
   */
  private getTradForNonContextualElement(): void {
    this.translateService.get('COMMON.VALIDATE').subscribe((res: string) => {
      this.buttonLabel = res;
    });
    this.translateService.get('TOASTER.ERROR_MESSAGE_TITLE').subscribe((res: string) => {
      this.errorTitle = res;
    });
    this.translateService.get('TOASTER.FAIL_REQUEST').subscribe((res: string) => {
      this.errorMessage = res;
    });
    this.translateService.get('FOLD.ACTION_COMPONENT.ACTION_CONFIRM_ONLY_FOLD').subscribe((res: string) => {
      this.labelOnlyFold = res;
    });
    this.translateService.get('FOLD.ACTION_COMPONENT.ACTION_CONFIRM_FULL_DEPOSIT').subscribe((res: string) => {
      this.labelAllDeposit = res;
    });
  }

  /**
   * spread information about the modal closure to the parent component
   */
  public closeComponent(): void {
    this.displayConfirmReplay = false;
    this.visible.emit(false);
  }

}
